module.exports = __webpack_public_path__ + "assets/menu-search-3bf3e4.svg";